import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { HOME_URL, VENUES } from "../../const/URL.const";
import { Auth } from 'aws-amplify';
import { useAuthenticationContext } from "../../yoello-lib/modules/auth/AuthenticationContext";
import setRedirectURLs from "../../yoello-lib/modules/URL/setRedirectURLs"
import { useSentry } from "../../hooks/useSentry";
import { useUserLogout } from "../../hooks/useUserLogout";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";

export function useAuthRedirect() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const venueID = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const Venue = useSelector(
        (state: IReduxAppState) => state.venue[venueID]?.venueData
    );
    const history = useHistory();
    const { logout } = useUserLogout();
    const { captureException } = useSentry();
    const { verifyAuth } = useAuthenticationContext();

    useEffect(()=>{
        if(!isAuthenticated || (Object.keys(venueID).length === 0 && !Venue)){
            if(history.location.pathname !== VENUES && history.location.pathname !== HOME_URL){
               setRedirectURLs(history.location.pathname)
               history.push(HOME_URL);
            }
        }
    // eslint-disable-next-line
    },[isAuthenticated])

    useEffect(() => {
        async function checkUserVerification() {
            try {
                const user = await verifyAuth();
                if (user) {
                    setIsAuthenticated(true);
                } 
            } catch (error: any) {
                if (error && error.code) {
                    captureException(error, "login-failure")
                    logout();
                }
            }
        }
        checkUserVerification();
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        const listen = history.listen(() => {
            Auth.currentAuthenticatedUser()
                .then(() => {
                   console.log("You Are Logged In")
                })
                .catch(() => {
                    if (isAuthenticated) {
                        setIsAuthenticated(false);
                    }
                })
        });
        return () => {
            listen();
        }
        // eslint-disable-next-line    
    }, [])

    return {
        isAuthenticated
    }
}